import tabPane from './tabPane';

export default {
  items: [{
    name: 'tab-1',
    title: 'tab-1',
    ...JSON.parse(JSON.stringify(tabPane)),
  }, {
    name: 'tab-2',
    title: 'tab-1',
    ...JSON.parse(JSON.stringify(tabPane)),
  }],
  style: {
    width: '100%',
    height: '250',
    position: 'absolute',
    left: 0,
  },
  dtEid: 'tab',
};
